import React, { useState } from 'react';
import { Col } from 'react-bootstrap';
import { Field, getIn, useFormikContext } from 'formik';
import moment from 'moment';
import { FormikInput, FormikNumber, FormikSelect } from '../../../components';
import { getEmployeeBalancesSettlement } from '../../../requests/payrollSettlements';

const DefaultNotVariableInput = () => {
  return (
    <>
      <Col md={5} className="sample-row">
        <FormikSelect placeholder="Seleccionar Concepto" isDisabled />
      </Col>
      <Col className="col-2 sample-row" />
      <Col md={4} className="sample-row">
        <FormikInput leftAddon="$" disabled />
      </Col>
    </>
  );
};

export default function NotVariableInput({
  valuePath,
  index,
  title,
  dispatch,
  errors,
  touched,
  setFieldValue,
  disabledAmount,
  addon,
  defaultValue,
  defaultOptions,
  disabledSelector
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { values } = useFormikContext();
  const employeeId = getIn(values, `employee[id]`);
  const endDate = getIn(values, 'endDate');

  const filterBalanceAmount = (payrollBalances, balanceID) => {
    if (!payrollBalances.length) {
      const defaultBalance = defaultOptions.find(balance => balance.id === balanceID);
      return defaultBalance?.code === 'HI01' ? values.employee?.salary : 0;
    }
    const _balance = payrollBalances.find(balance => balance?.balance?.id === balanceID);
    return _balance ? _balance.amount : 0;
  };

  const handleBalanceChange = selectedValue => {
    const selectedBalance = defaultOptions.find(balance => selectedValue === balance.id);
    if (!employeeId || !endDate) return;
    setIsLoading(true);
    const dateToSearch = moment(endDate, 'DD-MM-YYYY').subtract(1, 'months');
    const year = +dateToSearch.format('YYYY');
    const month = +dateToSearch.format('MM') - 1;
    getEmployeeBalancesSettlement({
      dispatch,
      params: {
        filter_employee_ids: [employeeId],
        filter_balance_ids: [],
        balance_code: selectedBalance.code,
        filter_active: true,
        payroll_process_date: `${year}-${month}`,
        settlement_date: endDate
      },
      successCallback: ({ data }) => {
        const amount = filterBalanceAmount(data, selectedValue);
        setFieldValue(`${valuePath}[${index}][parsedAmount]`, amount);
      },
      callback: () => setIsLoading(false)
    });
    setFieldValue(`${valuePath}[${index}][balance]`, selectedBalance);
  };

  return (
    <>
      <Col md={5}>
        <Field name={`${valuePath}[${index}][balanceId]`}>
          {({ field }) => (
            <FormikSelect
              {...field}
              abbr
              placeholder={`Seleccionar ${title}`}
              value={defaultValue}
              defaultValue={defaultValue}
              options={defaultOptions}
              onChange={data => {
                setFieldValue(field.name, data ? data.value : '');
                handleBalanceChange(data ? data.value : '');
              }}
              isDisabled={disabledSelector}
              error={getIn(errors, field.name)}
              touched={getIn(touched, field.name)}
            />
          )}
        </Field>
      </Col>
      <Col className="col-2 sample-row" />
      <Col md={4}>
        <Field name={`${valuePath}[${index}][parsedAmount]`}>
          {({ field }) => (
            <FormikNumber
              {...field}
              abbr
              decimalScale={addon === '$' ? 0 : 2}
              fieldName={`${valuePath}[${index}][amount]`}
              disabled={disabledAmount || isLoading}
              setFieldValue={setFieldValue}
              leftAddon={addon}
              errors={errors}
              touched={touched}
            />
          )}
        </Field>
      </Col>
    </>
  );
}

export { DefaultNotVariableInput };
